import { ColorCMYK, CoverParts } from 'shared/types/global'
import Flex from 'shared/ui/Flex'

import CoverBackgroundItem from './components/CoverBackgroundItem'

type CoverBackgroundsProps = {
  imageUrls: Record<CoverParts, string | null>
  colors: Record<CoverParts, ColorCMYK | null>
  onImageClick: (part: CoverParts) => void
  onColorClick: (part: CoverParts) => void
}

const CoverBackgrounds: React.FC<CoverBackgroundsProps> = ({
  imageUrls,
  colors,
  onImageClick,
  onColorClick
}) => {
  
  return (
    <Flex justifyContent="space-between">
      <CoverBackgroundItem
        titleId="Panel.coverStartEditing.background.back"
        onColorClick={() => onColorClick(CoverParts.back)}
        onImageClick={() => onImageClick(CoverParts.back)}
        imageUrl={imageUrls[CoverParts.back]}
        color={colors[CoverParts.back]}
      />
      <CoverBackgroundItem
        titleId="Panel.coverStartEditing.background.spine"
        onColorClick={() => onColorClick(CoverParts.spine)}
        onImageClick={() => onImageClick(CoverParts.spine)}
        imageUrl={imageUrls[CoverParts.spine]}
        color={colors[CoverParts.spine]}
      />
      <CoverBackgroundItem
        titleId="Front"
        onColorClick={() => onColorClick(CoverParts.front)}
        onImageClick={() => onImageClick(CoverParts.front)}
        imageUrl={imageUrls[CoverParts.front]}
        color={colors[CoverParts.front]}
      />
    </Flex>
  )
}

export default CoverBackgrounds
